import React, { useEffect, useState } from "react";
import { ScrollText, MessageCircle, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { timeAgo } from "../../lib/format";
import { Panel } from "./ui";
import { Header } from "./CorporateDashboard";

export default function AuditLog() {
  const [logs, setLogs] = useState(null);
  const [notifs, setNotifs] = useState(null);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setLogs(r.data));
    api.get("/admin/notifications").then((r) => setNotifs(r.data));
  }, []);

  return (
    <div className="space-y-6">
      <Header title="Audit Trail & Alerts" sub="Every significant action & WhatsApp notification is recorded" />
      <div className="grid lg:grid-cols-2 gap-6">
        <Panel title="Audit Log">
          {!logs ? <Loader2 className="animate-spin text-amber-400" /> : (
            <div className="space-y-2 max-h-[520px] overflow-y-auto" data-testid="audit-list">
              {logs.length === 0 && <p className="text-slate-600 text-sm py-6 text-center">No actions logged yet. Advance a KDS ticket to see entries.</p>}
              {logs.map((l, i) => (
                <div key={i} className="flex items-start gap-3 card-surface-2 rounded-xl p-3">
                  <ScrollText size={15} className="text-amber-400 mt-0.5 shrink-0" />
                  <div className="min-w-0">
                    <div className="text-sm font-medium capitalize">{(l.action || "").replace(/_/g, " ")}</div>
                    <div className="text-[11px] text-slate-500 truncate">{l.entity} · {l.user_email}</div>
                  </div>
                  <span className="ml-auto text-[11px] text-slate-600 whitespace-nowrap">{timeAgo(l.at)}</span>
                </div>
              ))}
            </div>
          )}
        </Panel>

        <Panel title="WhatsApp Notifications">
          {!notifs ? <Loader2 className="animate-spin text-amber-400" /> : (
            <div className="space-y-2 max-h-[520px] overflow-y-auto" data-testid="notification-list">
              {notifs.length === 0 && <p className="text-slate-600 text-sm py-6 text-center">No notifications yet.</p>}
              {notifs.map((n, i) => (
                <div key={i} className="flex items-start gap-3 card-surface-2 rounded-xl p-3">
                  <MessageCircle size={15} className="text-emerald-400 mt-0.5 shrink-0" />
                  <div className="min-w-0">
                    <div className="text-xs text-slate-300">{n.body}</div>
                    <div className="text-[11px] text-slate-600 mt-1">
                      → {n.to} · <span className={n.status === "sent" ? "text-emerald-400" : "text-amber-400"}>{n.status.toUpperCase()}</span>
                    </div>
                  </div>
                  <span className="ml-auto text-[11px] text-slate-600 whitespace-nowrap">{timeAgo(n.created_at)}</span>
                </div>
              ))}
            </div>
          )}
        </Panel>
      </div>
      <p className="text-[11px] text-slate-600">WhatsApp is in SIMULATED mode until Twilio credentials are added — messages are logged here and delivered live once keys are configured.</p>
    </div>
  );
}
